import { useEffect, useState } from "react";

/**
 * Draws the component again once the clock passes `at`: for what is shown "for three seconds" and
 * decided while rendering. Without it the screen only changes when the server next speaks, and a
 * quiet table kept an event toast up for a whole bid (review 0027 C5).
 */
export function useRedrawAt(at: number | null): void {
  const [, redraw] = useState(0);
  useEffect(() => {
    if (at === null) return;
    const left = at - Date.now();
    if (left <= 0) return;
    const timer = window.setTimeout(() => redraw((n) => n + 1), left);
    return () => window.clearTimeout(timer);
  }, [at]);
}
